/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_TitleInputs */

const en_mk_agent_1_title = /** @type {(inputs: Mk_Agent_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers from your whole plan`)
};

const id_mk_agent_1_title = /** @type {(inputs: Mk_Agent_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jawaban dari seluruh rencana`)
};

/**
* | output |
* | --- |
* | "Answers from your whole plan" |
*
* @param {Mk_Agent_1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_title = /** @type {((inputs?: Mk_Agent_1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_title(inputs)
	return en_mk_agent_1_title(inputs)
});